let config

if (process.env.VUE_APP_OWNER === 'erling') {
  config = {
    OWNER: 'erling',
    OWNER_NAME: 'Erling Holst-Larsen',
    NAME: 'Mekke Media',
    EMAIL: 'info@mekke.no',
    HOME_DOMAIN: 'mekke.no',
    HOME_URL: 'https://mekke.no/',
    MINSIDE_DOMAIN: 'minside.mekke.no',
    API_URL: 'https://api.minside.mekke.no/'
  }
} else if (process.env.VUE_APP_OWNER === 'ragnvald') {
  config = {
    OWNER: 'ragnvald',
    OWNER_NAME: 'Ragnvald Holst-Larsen',
    NAME: 'Romerike Internett',
    EMAIL: 'info@romerike.com',
    HOME_DOMAIN: 'romerike.com',
    HOME_URL: 'http://romerike.com',
    MINSIDE_DOMAIN: 'minside.romerike.com',
    API_URL: 'https://api.minside.romerike.com/'
  }
} else {
  throw new window.Exception('Mangler VUE_APP_OWNER')
}

if (process.env.NODE_ENV === 'development') {
  config.API_URL = 'http://localhost:5000/'
}

export default config
